export default __webpack_public_path__ + "static/media/your_hearing_loss.ac93729c.svg";